import { storyblokEditable } from "@storyblok/react/rsc";

import type {
  FeaturedCampsitesStoryblok,
} from "@/component-types-sb";
import { Card } from "@/components/layout/Card";
import { BodyText, Divider, H2 } from "@/components/typography";
import { useCampsiteOfferCounts } from "@/lib/hooks/useCampsiteOfferCounts";
import type { Dictionary } from "@/lib/types";

type FeaturedCampsitesPops = {
  blok: FeaturedCampsitesStoryblok;
  dict?: Dictionary;
};

const FeaturedCampsites = ({ blok, dict }: FeaturedCampsitesPops) => {
  const { hasOffer } = useCampsiteOfferCounts();

  return (
    <section
      className="py-8 mx-2 lg:mx-0 text-center"
      {...storyblokEditable(blok)}
    >
      <H2 colorScheme="primary">{blok.headline}</H2>
      <BodyText className="max-w-md mx-auto mt-2 text-center">
        {blok.text}
      </BodyText>

      <Divider />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        {blok.campsites?.map((nestedBlok: any, index) => (
          <Card
            key={nestedBlok.id}
            size={index === 0 ? "large" : "normal"}
            image={nestedBlok.content?.image}
            href={nestedBlok.full_slug}
            name={nestedBlok.name}
            text={nestedBlok.content?.lead}
            buttonLabel={dict?.discover}
            hasOffer={hasOffer(nestedBlok)}
          />
        ))}
      </div>
    </section>
  );
};

FeaturedCampsites.blockName = "featured_campsites";

export default FeaturedCampsites;
